















































































import { Vue, Component } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import list, {
  LearningGroupParams as ILearningGroupParams
} from "@/getinfo-api/learning-groups";
import CField from "@/components/form/CField.vue";
import { EmployeesListClass } from "@/classes/list/EmployeesListClass";
import { getCurrentCompanyId } from "@/plugins/roles";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import { CoursesListClass } from "@/classes/list/CoursesListClass";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import LearningGroupTable from "@/components/learning-group/LearningGroupTable.vue";
import { LearningGroup as ILearningGroup } from "@/api-v2/learning-group/models";

@Component({
  components: { LearningGroupTable, CBlock, CSingleSelect, CField, CPage }
})
export default class LearningGroupList extends Vue {
  groups: ILearningGroup[] = [];
  isLoading: boolean = false;
  count: number = 0;
  pageNumber: number = 1;

  employees: EmployeesListClass = new EmployeesListClass(
    {
      id: this.selectedCompany,
      roles: ["content_manager"],
      limit: 900
    },
    this.selectedCompany
  );
  coursesList: CoursesListClass = new CoursesListClass({ mode: "v2" });


  filter: ILearningGroupParams = {
    companyId: this.selectedCompany,
    limit: 30,
    offset: 0
  };

  get selectedCompany() {
    return getCurrentCompanyId();
  }

  submitSettings() {
    this.isLoading = true;
    list(this.filter)
      .then(res => {
        this.groups = res.data.items;
        this.count = res.data.count;
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
  clearFilter() {
    this.filter = {
      companyId: this.selectedCompany,
      limit: 30,
      offset: 0
    };
    this.submitSettings();
  }

  changePage() {
    this.$nextTick(() => {
      if (this.filter && this.filter.limit) {
        this.filter.offset = this.filter.limit * (this.pageNumber - 1);
        this.submitSettings();
      }
    });
  }

  created() {
    this.submitSettings();
  }
}
